import { useParams, useSearchParams } from "react-router-dom";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import Spinner from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { Search, UserMinus } from "react-feather";
import UserSearch from "../Settings/SearchScreen/User/User";
import "./style.css"
import { debounce } from "lodash";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { UserSearchLoadin } from "../Settings/SearchScreen/User/UserSearchLoading";
import { LIMIT_REQUEST_FOLLOWERS } from "../../utils/vars";
import { errorMessage } from "../../utils/TextManagerTwo";
import { User } from "../../global-components/src/types";

const FollowersScreen = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [termo, setTermo] = useState(searchParams.get("termo") || "");
    const [termoSearch, setTermoSearch] = useState(termo);
    const { id: userId } = useParams();
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [followers, setFollowers] = useState<User[] | null>(null);
    const [followersType, setFollowersType] = useState("all");
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [loadingTermo, setLoadingTermo] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(() => { return 1; });
    const { token, user: userAuthenticated } = useAuth();
    const [hasMore, setHasMore] = useState(true);
    const [dataNotFound, setDataNotFound] = useState(false); // Adicione um estado para a senha

    const changeFollowersType = (type: string) => {
        setEnd(false);
        setLoading(false)
        setPage(1); // Mude para 1 para a primeira página
        setFollowers([]);

        // Se o tipo for diferente, atualizar o estado
        if (type !== followersType) {
            setFollowersType(type);
        } else {
            // Se for o mesmo, apenas recarregar os dados
            loadFollowers(1);
        }
    }

    const loadFollowers = async (newPage?: number) => {
        setDataNotFound(false);
        
        const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        const url = PACOCA_API_URL + `/users/followers/${userId}?page=${currentPage}&limit=${LIMIT_REQUEST_FOLLOWERS}&followersType=${followersType}&search=${termoSearch}`;

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.followers.length > 0) {
                setFollowers((prevData) => {
                    const existingIds = new Set(prevData?.map((f) => f.id)); // Coleta os IDs já existentes
                    const newFollowers = data.followers.filter((f: { id: number; }) => !existingIds.has(f.id)); // Filtra os novos

                    setHasMore(!(data.followers.length < LIMIT_REQUEST_FOLLOWERS));
                    return [...(prevData || []), ...newFollowers];
                });

            } else {
                setHasMore(false);
            }

        } catch (err: any) {
            const messageError = errorMessage(err)
            setMessage(messageError, "error");
            console.error('Erro:', err);
            setEnd(true);
        } finally {
            setLoading(false);
            setLoadingTermo(false);
        }
    };

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if ((scrollTop + clientHeight >= scrollHeight - 50) && !end && !loading && hasMore) {
                setPage((prevPage) => prevPage + 1); // Agora a página é atualizada antes da requisição
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, [end, loading]);

    const debouncedHandleInput = useCallback(debounce(setTermoSearch, 500), [termoSearch]);

    useEffect(() => {
        loadFollowers(page);
    }, [termoSearch, page, followersType]); // Um único useEffect para tratar tudo

    useEffect(() => {
        setLoadingTermo(true);
    }, [termo]); // Um único useEffect para tratar tudo


    useEffect(() => {
        if (followers?.length) {
            setLoadingTermo(false)
        }
    }, [followers]); // Um único useEffect para tratar tudo


    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting && !loading && !end) {
                // setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    useEffect(() => {
        // Salva a posição de rolagem quando o feed for modificado
        const handleScroll = () => {
            sessionStorage.setItem("scrollPosition", window.scrollY.toString());
        };

        window.addEventListener("scroll", handleScroll)

        return () => {
            window.removeEventListener("scroll", handleScroll)
        };
    }, []);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setTermo(inputValue);
        setLoadingTermo(true);
        debouncedHandleInput(inputValue)
        setFollowers([])
        setPage(1)
        setEnd(false)
        setSearchParams({ termo: inputValue }, { replace: true })
    };

    return (
        <>
            <Screen paddingTopTitle={true} title="Seguidores">
                <Helmet>
                    <title>Paçoca - Seguidores</title>
                </Helmet>

                <>
                <div className="d-flex container-search-followers container-search-padding" style={{marginTop: "0px"}}>
                        <input
                            id="input-search-screen"
                            className="form-control input-search input-search-screen input-search-followers"
                            type="text"
                            name="search"
                            placeholder="Pesquisar"
                            aria-label="Search"
                            required
                            value={termo}
                            onChange={handleChange}
                        />
                        <button className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                            <Search color="#d3d3d3" />
                        </button>
                    </div>

                    <div className="row row row-fillter-search">
                        <button className={`btn col-notification btn-light all ${followersType == "all" ? "notification-type-active" : ""}`} onClick={() => changeFollowersType("all")}>
                            <p>Todos</p>
                        </button>
                        
                        {userId != userAuthenticated?.id ? (
                            <button className={`btn col-notification btn-light mention ${followersType == "follow_you" ? "notification-type-active" : ""}`} onClick={() => changeFollowersType("follow_you")}>
                                <p>Segue você</p>
                            </button>
                        ) : null}

                        <button className={`btn col-notification btn-light mention ${followersType == "you_follow" ? "notification-type-active" : ""}`} onClick={() => changeFollowersType("you_follow")}>
                            <p>Você segue</p>
                        </button>
                    </div>


                    {followers?.map((user, index) => (
                        <UserSearch
                            clasNameSearch=""
                            clasImgAccount="img-list-chat"
                            key={index}
                            user={user}
                            isMyFollowers={userId == userAuthenticated?.id}
                            setFollowers={setFollowers}
                        />
                    ))}

                    <UserSearchLoadin quantity={followers?.length ? 1 : 6} loading={(loading || loadingTermo) && !dataNotFound} />
                    <p ref={endOfListRef}></p>

                    {!followers?.length && !loading && !loadingTermo ? (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <UserMinus className="icon-empty" />
                                <h3 className="w-100 text-center">Nenhum usuário</h3>
                            </span>
                        </div>

                    ) : null}
                </>
            </Screen>
        </>
    );
};

export default FollowersScreen;